import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { Rectangle } from "pixi.js";
import { AnimationContents } from "../../../AnimationContents";
import { ButtonController } from "../../Common/ButtonController";
import { LocalizationContents } from "../../LocalizationContents";
import { GameLogic } from "../../Logic/GameLogic";
import { GameModel } from "../../Models/GameModel";
import { resizeScreen } from "../../Utils/Resize";

export class CreditsModalScreen extends AnimationBaseController {
    $model: GameModel;
    constructor(
        @Inject private options: { exit: () => void },
        @Inject private gameLogic: GameLogic,
    ) {
        super("CreditsModalScreen");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.SETTINGS_JSON,
            libraryName: "modal_developers",
            childControllers: {
                exit_btn: {
                    instanceName: "btn_exit_modal",
                    controller: ButtonController,
                    options: {
                        onClick: this.options.exit,
                    }
                },
                // developers: {
                //     instanceName: "btn_learn_more",
                //     controller: ButtonController,
                //     options: {
                //         onClick: () => {
                //             window.location.href = "https://nordbeaver.com/"
                //         },
                //     }
                // }
            }
        }
    }

    protected onInitialize(): void {
        this.localise();
        this.getDisplayObjectByQuery("btn_exit_modal")[0].hitArea = new Rectangle(-100, -100, 200, 200);
    }

    protected onResize(width: number, height: number, scale: number): void {
        resizeScreen(width, height, scale, this);
    }

    localise(): void {
        this.setTextByQuery("title_credits", LocalizationContents.getText("title_credits"));
        this.setTextByQuery("btn_learn_more.button_next", LocalizationContents.getText("button_credits"));
        this.setTextByQuery("text_credits", LocalizationContents.getText("text_credits"));
        this.setTextVerticalAlignByQuery("btn_learn_more.button_next", "middle");
        this.setTextVerticalAlignByQuery("text_credits", "middle");
        this.setTextVerticalAlignByQuery("title_credits", "middle");
    }
}